import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Component, OnInit } from '@angular/core';
import { UserProfilesService } from '@app/core/services/user-profiles.service';
import { UserProfile } from '@core/models/user-profile';
import { TranslateService } from '@ngx-translate/core';
import { IndeterminateHorizontalProgressIndicatorComponent } from '@shared/components/indeterminate-horizontal-progress-indicator/indeterminate-horizontal-progress-indicator.component';
import { OrderCreatorService } from '@shared/services/order-creator.service';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';
import { SubSink } from 'subsink';
import {AuthService} from '@core/services/auth.service';
import {ExternalPlannerLoginResponse} from '@core/models/external-planner-login-response.model';

@Component({
    selector: 'cass-my-ads-page',
    templateUrl: './my-ads-page.component.html',
    styleUrls: ['./my-ads-page.component.css']
})
export class MyAdsPageComponent implements OnInit {

	private userProfile: UserProfile | undefined;
	private externalPlanInfo: ExternalPlannerLoginResponse | undefined;

	displayMode: "showAll" | "showRecent" | "externalPlanner" = 'showAll'

	private readonly _callingOut$ = new BehaviorSubject<boolean>(false);
	private _fullscreenProgressOverlayRef?: OverlayRef;

	private subs = new SubSink();
    constructor(
		private _userProfileService: UserProfilesService,
		private _orderCreator: OrderCreatorService,
		private _translate: TranslateService,
		private _overlay: Overlay,
		private _authService: AuthService,
	) { }

	ngOnInit() {
		this.externalPlanInfo = this._authService.getExternalPlannerInfo;
		if (this.externalPlanInfo) {
			this.displayMode = 'externalPlanner'
		}
		this.subs.add(
			this._userProfileService.userProfile$.subscribe((profile: UserProfile | undefined) => this.userProfile = profile)
		);

		this._fullscreenProgressOverlayRef = this._overlay.create({
			positionStrategy: this._overlay.position().global().centerHorizontally().centerVertically(),
			hasBackdrop: true
		});

		this.subs.add(
			this._callingOut$.pipe(distinctUntilChanged()).subscribe(show => {
				if (show) {
					const componentRef = this._fullscreenProgressOverlayRef?.attach(new ComponentPortal(IndeterminateHorizontalProgressIndicatorComponent));
					if (componentRef) {
						this._translate.get("APP_NOTIFICATIONS.PLEASE_WAIT_MESSAGE").subscribe((msg) => componentRef.instance.displayString = msg);
					}
				}
				else {
					this._fullscreenProgressOverlayRef?.detach();
				}
			}));
	}

	ngOnDestroy(): void {
		this.subs.unsubscribe();
	}

	createOrder() {
		this._callingOut$.next(true);
		this.subs.add(
			this._orderCreator.init().subscribe({
				next: () => {
					this._callingOut$.next(false);
					this._orderCreator.startOrderCreationFlow();
				},
				error: (error) => {
					this._callingOut$.next(false);
				}
			})
		);
	}
}
